export const trustPilotStyles = {
  main: {
    background: "#000032",
  },
  wrapper: {
    display: "flex",
    flexDirection: "column",
  },
  top: {
    display: "flex",
    // justifyContent: "space-between",
    justifyContent: "flex-start",
    alignItems: "end",
    // flexWrap: "wrap",
    marginBottom: "24px",
  },
  title: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "start",
  },
  icon: {
    marginRight: "2.7px",
    color: "#00B67A",
  },
  text: {
    fontWeight: 500,
    fontSize: "17px",
    lineHeight: "27px",
    color: "#FFFFFF",
  },
  middle: {
    marginBottom: "24px",
  },
  middlePercDetails: {
    fontWeight: 400,
    fontSize: "17px",
    lineHeight: "22px",
    color: "#FFFFFF",
  },
  bottom: {
    display: "flex",
    color: "#00C48C",
  },
  bottomText: {
    fontWeight: 400,
    fontSize: "17px",
    lineHeight: "20px",
    textDecorationLine: "underline",
    marginRight: "12px",
    cursor: "pointer",
  },
  positive: {
    color: "#00C48C",
  },
  addition: {
    fontWeight: 600,
  },
};
